module.exports = __webpack_public_path__ + "img/qr-2.92f0d6ad.png";